import { createSlice, CaseReducer, PayloadAction } from '@reduxjs/toolkit';

import { get } from 'api/requests';

import { AppThunk } from 'store/types';
import {
  AllPlanChangeVersionData,
  DetailVersionPlan,
  PlanAllVersionState,
} from 'features/PlanAllVersions/types';

const initialState: PlanAllVersionState = {
  loading: false,
  count: 0,
  list: [],
  detail: {} as DetailVersionPlan,
};

const loading: CaseReducer<PlanAllVersionState, PayloadAction<boolean>> = (state, action) => {
  state.loading = action.payload;
};

const count: CaseReducer<PlanAllVersionState, PayloadAction<number>> = (state, action) => {
  state.count = action.payload;
};

const list: CaseReducer<PlanAllVersionState, PayloadAction<AllPlanChangeVersionData[]>> = (
  state,
  action,
) => {
  state.list = action.payload;
};

const detail: CaseReducer<PlanAllVersionState, PayloadAction<DetailVersionPlan>> = (
  state,
  action,
) => {
  state.detail = action.payload;
};

export const planAllVersionsSlice = createSlice({
  name: 'planAllVersions', // CHANGE_
  initialState,
  reducers: {
    loading,
    count,
    list,
    detail,
  },
});

const {
  loading: setLoading,
  count: setCount,
  list: setListPlans,
  detail: setChangeDetailPlan,
} = planAllVersionsSlice.actions;

const setPlans =
  (plans: AllPlanChangeVersionData[]): AppThunk =>
  dispatch => {
    dispatch(setListPlans(plans || []));
  };

const setDetail =
  (planDetail: DetailVersionPlan): AppThunk =>
  dispatch => {
    dispatch(setChangeDetailPlan(planDetail || {}));
  };

export const getAllVersionsPlans =
  (params: { project?: number; start?: string; end?: string }): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    get<Resp>('/api/settlement/version/', params)
      .then(({ data }) => {
        const { results, count } = data;
        dispatch(setPlans(results));
        dispatch(setCount(count));
      })
      .finally(() => dispatch(setLoading(false)));
  };

type Resp = { results: AllPlanChangeVersionData[]; count: number };

export const getDetailVersionsPlans =
  (id: number): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    get<DetailVersionPlan>(`/api/settlement/version/${id}`)
      .then(({ data }) => {
        dispatch(setDetail(data));
      })
      .finally(() => dispatch(setLoading(false)));
  };
